
import React, { useState, useEffect,useRef } from 'react';
import '../Styles/Hero.css';
import { FiPhone, FiMenu, FiX } from "react-icons/fi";
import logo from '../Resource/prasiddh-logo-1.png';
import {
  getCampaignId,
  getConversionLabel,
  gtag_report_conversion,
} from './ConversionHandler.js';


export const Hero = ({ onContactClick }) => {
  const [activeLink, setActiveLink] = useState('Home');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // silder-js
    const originalSlides = [
  {
    image: require('../Resource/slider1.jpg'),
    title: 'Escape to Nature’s Embrace',
    subtitle: 'Discover peace, privacy, and pristine beauty in every stay',
  },
  {
    image: require('../Resource/slider2.png'),
    title: 'Reconnect with Simplicity',
    subtitle: 'Let the serenity of the wild renew your soul',
  },
  {
    image: require('../Resource/slider3.png'),
    title: 'Your Gateway to Calm',
    subtitle: 'Unplug and unwind in untouched natural surroundings',
  }
];


  const [imageSet, setImageSet] = useState(originalSlides);
      const sliderRef = useRef(null);
      const [isSliding, setIsSliding] = useState(false);

      useEffect(() => {
        const interval = setInterval(() => {
          // Step 1: Immediately rotate image + text set
          setImageSet((prev) => {
            const next = [...prev.slice(1), prev[0]];
            return next;
          });

          // Step 2: Trigger the visual slide
          if (sliderRef.current) {
            sliderRef.current.style.transition = 'none';
            sliderRef.current.style.transform = 'translateX(100vw)'; 

            // Give browser a moment to apply transform before sliding
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                sliderRef.current.style.transition = 'transform 0.8s ease-in-out';
                sliderRef.current.style.transform = 'translateX(0)';
              });
            });
          }
        }, 5000);

        return () => clearInterval(interval);
      }, []);

  // silder-js

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setIsMenuOpen(false);
    if (link === 'Contact') {
      onContactClick(); // 🔔 Trigger popup from parent
    }
  };
  
   useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setScrolled(scrollY > window.innerHeight); // scrollY > 100vh
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Google-Tags -start
    const campaignId = getCampaignId();
  
    const handlePhoneClick = () => {
      const label = getConversionLabel('phone', campaignId);
      console.log('📞 Phone icon clicked - Conversion Label:', label);
      gtag_report_conversion('tel:+919986800600', label);
    };

  // Google-Tags -end


  return (
    <div className='Prasiddh-Hero-Container' id='Home'>
      <div className='Prasiddh-Hero-Container-inner-slider'  style={{
    backgroundImage: `url(${imageSet[2]?.image})`}} >

      {/* Image Slider */}
       <div className="Prasiddh-Hero-Slider-Slide">
        <div className="slider-wrapper" ref={sliderRef}>
          {imageSet.map((slide, i) => (
            <img key={i} src={slide.image} alt={`slide-${i}`} />
          ))}
        </div>
      </div>
      


      

      {/* Navbar */}
      <nav className={`Prasiddh-hero-navbar ${scrolled ? 'scrolled-navbar' : ''}`}>
        <div className="Prasiddh-hero-links desktop-only">
          {['Home', 'About', 'Gallery','Resort', 'Contact'].map((link) => (
            <a
              key={link}
              className={`Prasiddh-hero-link ${activeLink === link ? 'active' : ''}`}
              href={link === 'Contact' ? '#' : `#${link}`}
              onClick={() => handleLinkClick(link)}
            >
              {link}
            </a>
          ))}
        </div>

        {/* Contact Info */}
        <div className="Prasiddh-hero-contact desktop-only" onClick={handlePhoneClick}>
          <FiPhone className="Prasiddh-hero-phone-icon" />
          <span className="Prasiddh-hero-phone-number">9986 800 600</span>
        </div>

        {/* Hamburger Icon for Mobile */}
        <div className="Prasiddh-nav-hamburger mobile-only" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? <FiX size="30px" color="white" /> : <FiMenu size="30px" color="white" />}
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`Prasiddh-nav-mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        {['Home', 'About', 'Gallery', 'Resort', 'Contact'].map((link) => (
          <a
            key={link}
            className="Prasiddh-nav-mobile-link"
            href={link === 'Contact' ? '#' : `#${link}`}
            onClick={() => handleLinkClick(link)}
          >
            {link}
          </a>
        ))}
      </div>

      {/* whatsapp and phone */}
      
      {/* Hero Center Content */}
      <div className='Prasiddh-hero-Center'>
        <img src={logo} className='Prasiddh-Hero-logo' alt="logo" />
        <h1 key={imageSet[0].title} className="Prasiddh-hero-Center-h1">
          {imageSet[0].title}
        </h1>
        <p key={imageSet[0].subtitle} className="Prasiddh-hero-Center-p">
          {imageSet[0].subtitle}
        </p>

        <a href='#contact'>
          <button className='Prasiddh-hero-Center-btn' onClick={onContactClick}>Enquire Now</button>
        </a>
      </div>
        </div>
    </div>
  );
};
